import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const isBirthdayPage = location.pathname === '/cumpleanos';

  return (
    <header className="app-header">
      <div 
        className="container header-content"
        style={{ justifyContent: isBirthdayPage ? 'flex-end' : 'space-between' }}
      >
        {!isBirthdayPage && (
          <div className="logo-title">
            <NavLink to="/">Visor de Promociones</NavLink>
          </div>
        )}
        <nav className="main-nav">
          <NavLink 
            to={isBirthdayPage ? "/" : "/cumpleanos"} 
            className="btn"
          >
            {isBirthdayPage ? "Ver Promociones" : "Cumpleaños"}
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default Header;